import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";
import { EVENTBRITE_URL, LOGO_URL } from "../../lib/api";

const links = [
  { label: "HOME", href: "#home" },
  { label: "ABOUT", href: "#about" },
  { label: "SPONSORSHIP", href: "#sponsorship" },
  { label: "SCHOLARSHIPS", href: "#scholarships" },
  { label: "AWARDS", href: "#awards" },
  { label: "NEWS", href: "#news" },
  { label: "HOTELS", href: "#hotels" },
  { label: "MEDIA ROOM", href: "#media" },
  { label: "VOLUNTEERS", href: "#volunteers" },
  { label: "VENDORS", href: "#vendors" },
  { label: "CONTACT", href: "#contact" },
];

export default function Navigation() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <header
      data-testid="site-navigation"
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-500 ${
        scrolled ? "glass-panel py-3" : "bg-transparent py-5"
      }`}
    >
      <div className="max-w-[1500px] mx-auto px-6 md:px-10 flex items-center justify-between gap-6">
        <a href="#home" data-testid="nav-logo" className="flex items-center gap-3 shrink-0">
          <img src={LOGO_URL} alt="AAWTA" className="h-11 w-11 object-contain bg-white/95 rounded-full p-1" />
          <div className="hidden sm:block leading-tight">
            <p className="text-overline text-aawta-pink">AAWTA · 2026</p>
            <p className="font-display text-base text-white">Power to Drive Change</p>
          </div>
        </a>

        <nav className="hidden xl:flex items-center gap-6 text-[11px] tracking-[0.2em] font-medium text-white/80">
          {links.map((l) => (
            <a
              key={l.label}
              href={l.href}
              data-testid={`nav-link-${l.label.toLowerCase().replace(/\s/g, "-")}`}
              className="hover:text-aawta-pink transition-colors"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="hidden md:flex items-center gap-3">
          <a href="#donate" data-testid="nav-donate-btn" className="btn-ghost py-2.5 px-4 text-xs">
            DONATE
          </a>
          <a
            href={EVENTBRITE_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="nav-tickets-btn"
            className="btn-pink py-2.5 px-4 text-xs"
          >
            GET TICKETS
          </a>
        </div>

        <button
          data-testid="nav-mobile-toggle"
          onClick={() => setOpen(!open)}
          className="xl:hidden text-white p-2"
          aria-label="Toggle menu"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div data-testid="mobile-menu" className="xl:hidden glass-panel mt-3 mx-4 p-6 flex flex-col gap-4">
          {links.map((l) => (
            <a
              key={l.label}
              href={l.href}
              onClick={() => setOpen(false)}
              className="text-overline text-white/80 hover:text-aawta-pink"
            >
              {l.label}
            </a>
          ))}
          <div className="flex gap-3 pt-3 border-t border-white/10">
            <a href="#donate" onClick={() => setOpen(false)} className="btn-ghost flex-1 py-2.5 text-xs">DONATE</a>
            <a href={EVENTBRITE_URL} target="_blank" rel="noopener noreferrer" className="btn-pink flex-1 py-2.5 text-xs">
              GET TICKETS
            </a>
          </div>
        </div>
      )}
    </header>
  );
}
